import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(theme => ({
  carousel: {
    '& .css-1abc02a, & .css-hn784z': {
      '& button': {
        '& svg': {
          width: '3rem',
          height: '3rem',
          color: theme.palette.primary.main,
        },
      },
    },
  },
  disabled: {
    zIndex: 0,
  },
}));
